<div style="height: 500px">
    <emma-loading *ngIf="loading"></emma-loading>
    <div [id]="identifier" style="height: 500px"></div>
</div>
